import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleFService {

  constructor(private http: HttpClient) { }

  saveScheduleF(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=eanflf`;

    const params = _.merge({}, globalParams, filterParams);
    const payload = _.extend({
      jsonObj: JSON.stringify(scheduleDetails),
      jsonSettings: JSON.stringify(scheduleSettings),
      process_name: 'Schedule_F_Save',
      is_issue_key_enabled: globalParams?.is_issue_key_enabled,
      scenarioCode: globalParams?.scenarioCode
    }, params);

    const formData = new FormData();
    Object.keys(payload).forEach(key => {
      if (payload[key] !== null && payload[key] !== undefined) {
        formData.append(key, payload[key].toString());
      }
    });

    const options = {
      withCredentials: true
    };

    return this.http.post<any>(url, formData, options);
  }
}
